import script from "./integraladd.vue?vue&type=script&setup=true&lang=js"
export * from "./integraladd.vue?vue&type=script&setup=true&lang=js"

import "./integraladd.vue?vue&type=style&index=0&id=17ce13b4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17ce13b4"]])

export default __exports__